<template>
    <div class="layout">
        <div class="cabinet-page_bg"></div>

        <Header/>

        <div class="main-content-wrapper">
            <div class="main-content">
                <h1 v-html="$ml.with('VueJS').get('privacyPolicyPage.privacyPolicyTitle')"></h1>
                <div v-html="$ml.get('privacyPolicyText')">
                </div>
            </div>
        </div>


        <Contacts/>

        <Footer/>
        <AuthorizationWindow/>
    </div>
</template>

<script>
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import Contacts from '@/components/Contacts';
    import AuthorizationWindow from "../components/windows/AuthorizationWindow";
    import constants from  '../constants'
    import { MLBuilder } from 'vue-multilanguage'


    export default {
        name:'PrivacyPolicy',

        metaInfo: {
            title: 'Соглашение на обработку персональных данных'
        },

        beforeCreate() {
            $('body').attr('class', 'agreement-page index-layout');
        },


        components: {
            AuthorizationWindow,
            Header, Footer, Contacts,
            constants
        },

        computed: {
            mlprivacyPolicyText() {
                return new MLBuilder('privacyPolicyPage.privacyPolicyText')
                    .with('email', constants.APP_EMAIL)
                    .with('mainPage', constants.APP_MAIN_PAGE);
            }
        }
    }
</script>
